import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import dateFormat from "dateformat";
import { Container, Row } from "reactstrap";
import Box from "@mui/material/Box";
import AuditTable from "./AuditTable.js";

const AuditResultpage = () => {
  const [hostlist, setlist] = useState([]);
  useEffect(() => {
    const platform = window.sessionStorage.getItem("platform");
    const auditID = window.sessionStorage.getItem("auditID");
    fetch(
      `${process.env.REACT_APP_API_URL}/api/templatedetailview/${platform}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setlist(resp[0]))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      {window.localStorage.getItem("audit_run_limit") ===
      "License limitation crossed" ? (
        <Marquee pauseOnHover="false" style={{ color: "red" }}>
          You have utilized all your trail "Audit", Please contact{" "}
          <a
            href="mailto:sales@zippyops.com"
            style={{ marginLeft: "5px", color: "red" }}
          >
            sales@zippyops.com
          </a>{" "}
          for subscription.
        </Marquee>
      ) : (
        ""
      )}
      <React.Fragment>
        <Container className="mt--6" fluid>
          <Row className="mt-3">
            <div className="col">
              <AuditTable CisResults={hostlist.Result} />
            </div>
          </Row>
        </Container>
      </React.Fragment>
    </>
  );
};
export default AuditResultpage;